import React from 'react';
import { Box, Typography, Button, Modal, Stack } from '@mui/material';
import { ACTION_BLUE } from '../../../../theme/theme';

interface DownloadModalProps {
  open: boolean; // وضعیت باز یا بسته بودن Modal
  onClose: () => void; // تابع برای بستن Modal
  downloadUrl?: string; // لینک دانلود
}

const DownloadModal: React.FC<DownloadModalProps> = ({
  open,
  onClose,
  downloadUrl,
}) => {
  const handleDownload = () => {
    if (downloadUrl) {
      window.open(downloadUrl, '_blank'); // باز کردن لینک دانلود در تب جدید
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '70%',
          right: '1px',
          transform: 'translate(-50%, -50%)',
          width: 300,
          bgcolor: 'background.paper',
          borderRadius: 1,
          boxShadow: 24,
          p: 16,
          m: 8,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textAlign: 'right',
            color: '#25282E',
            fontSize: 16,
            fontFamily: 'IRANYekanXFaNum',
            fontWeight: 700,
            lineHeight: '20px',
            mb: 2,
          }}
        >
          {downloadUrl ? 'دانلود نسخه' : 'خطا'}
        </Typography>

        <Typography
          sx={{
            textAlign: 'right',
            color: '#60646E',
            fontSize: 14,
            fontFamily: 'IRANYekanXFaNum',
            fontWeight: 600,
            mb: 3,
          }}
        >
          {downloadUrl
            ? 'آیا می‌خواهید نسخه را دانلود کنید؟'
            : 'لینک دانلود موجود نیست!'}
        </Typography>

        <Stack direction="row" justifyContent="flex-end" spacing={8}>
          {downloadUrl && (
            <Button
              variant="contained"
              onClick={handleDownload}
              sx={{
                backgroundColor: ACTION_BLUE,
                color: 'white',
                fontSize: 12,
                fontFamily: 'IRANYekanXFaNum',
                fontWeight: 500,
                '&:hover': {
                  backgroundColor: ACTION_BLUE,
                },
              }}
            >
              دانلود
            </Button>
          )}
          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              backgroundColor: '#FFD6DB',
              color: '#EF4056',
              fontSize: 12,
              fontFamily: 'IRANYekanXFaNum',
              fontWeight: 500,
              '&:hover': {
                backgroundColor: '#FFD6DB',
              },
            }}
          >
            بستن
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default DownloadModal;
